import React, { useState, useEffect } from "react";
import ContentLoader from "react-content-loader";
import { Link, useLocation } from "react-router-dom";
import Tooltip from "@tippyjs/react";

import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import TaxRatesService from "../../../services/accounting/taxrateService";

function TaxRateView() {
  const [zipcode, setZipCode] = useState("");
  const [taxregion, setTaxRegion] = useState("");
  const [combinedrate, setCombinedRate] = useState(0);
  const [staterate, setStateRate] = useState(0);
  const [countyrate, setCountyRate] = useState(0);
  const [cityrate, setCityRate] = useState(0);
  const [specialrate, setSpecialRate] = useState(0);
  const [startDate, setStartdate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [state_name, setState_Name] = useState("");
  const [loading, setLoading] = useState(true);

  const { state } = useLocation();

  useEffect(() => {
    TaxRatesService.TaxRateGet(state).then((response) => {
      setState_Name(response.data.response.state_name);
      setZipCode(response.data.response.zip);
      setTaxRegion(response.data.response.tax_region);
      setCombinedRate(response.data.response.combined_rate);
      setStateRate(response.data.response.state_rate);
      setCountyRate(response.data.response.county_rate);
      setCityRate(response.data.response.city_rate);
      setSpecialRate(response.data.response.special_rate);
      setStartdate(response.data.response.start_date);
      setEndDate(response.data.response.end_date);
      setLoading(false);
    })
  }, []);

  return (
    <>
      <div className="container-fluid">
        {loading === false ? (
          <>
            <div className="header pb-0 ">
              <div className="d-lg-flex pt-2">
                <div>
                  <h5>{t("Tax Rates Details")}</h5>
                  <h6>
                    <Link to="/taxrateview" className="tc">
                      {t("Tax Rates")}
                    </Link>{" "}
                    / <span>{t("View Tax Rates")}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div className="card ">
              <div className="card-body">
                <div className="col-md-8">
                  <div className=" row">
                    <div className="col-xl-3">
                      <label className="col-lg-12 col-form-label">
                        {t("State")}{" "}
                        <Tooltip content={t("State_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                    </div>
                    <div className="col-xl-3">
                      <span className="col-lg-8 view-label p">
                        {state_name ? state_name : "None"}
                      </span>
                    </div>
                    <div className="col-xl-3">
                      <label className="col-lg-12 col-form-label">
                        {t("Zip Code")}{" "}
                        <Tooltip content={t("ZipCode_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                    </div>
                    <div className="col-xl-3">
                      <span className="col-lg-8 view-label p">
                        {zipcode ? zipcode : ""}
                      </span>
                    </div>
                  </div>
                  <div className=" row">
                    <div className="col-xl-3">
                      <label className="col-lg-12 col-form-label">
                        {t("Tax Region")}{" "}
                        <Tooltip content={t("TaxRegion_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                    </div>
                    <div className="col-xl-3">
                      <span className="col-lg-8 view-label p">
                        {taxregion ? taxregion : ""}
                      </span>
                    </div>
                    <div className="col-xl-3">
                      <label className="col-lg-12 col-form-label">
                        {t("Combined Rate")}{" "}
                        <Tooltip content={t("CombinedRate_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                    </div>
                    <div className="col-xl-3">
                      <span className="col-lg-8 view-label p">
                        {combinedrate ? Helper.TaxRateAmount(combinedrate) : "0.00"}
                      </span>
                    </div>
                  </div>
                  <div className=" row">
                    <div className="col-xl-3">
                      <label className="col-lg-12 col-form-label">
                        {t("State Rate")}{" "}
                        <Tooltip content={t("StateRate_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                    </div>
                    <div className="col-xl-3">
                      <span className="col-lg-8 view-label p">
                        {staterate ? Helper.TaxRateAmount(staterate) : "0.00"}
                      </span>
                    </div>
                    <div className="col-xl-3">
                      <label className="col-lg-12 col-form-label">
                        {t("County Rate")}{" "}
                        <Tooltip content={t("CountyRate_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                    </div>
                    <div className="col-xl-3">
                      <span className="col-lg-8 view-label p">
                        {countyrate ? Helper.TaxRateAmount(countyrate) : "0.00"}
                      </span>
                    </div>
                  </div>
                  <div className=" row">
                    <div className="col-xl-3">
                      <label className="col-lg-12 col-form-label">
                        {t("City Rate")}{" "}
                        <Tooltip content={t("CityRate_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                    </div>
                    <div className="col-xl-3">
                      <span className="col-lg-8 view-label p">
                        {cityrate ? Helper.TaxRateAmount(cityrate) : "0.00"}
                      </span>
                    </div>
                    <div className="col-xl-3">
                      <label className="col-lg-12 col-form-label">
                        {t("Speical Rate")}{" "}
                        <Tooltip content={t("SpecialRate_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                    </div>
                    <div className="col-xl-3">
                      <span className="col-lg-8 view-label p">
                        {specialrate ? Helper.TaxRateAmount(specialrate) : "0.00"}
                      </span>
                    </div>
                  </div>
                  <div className=" row">
                    <div className="col-xl-3">
                      <label className="col-lg-12 col-form-label ">
                        {t("Start Date")}{" "}
                        <Tooltip content={t("StartDate_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                    </div>
                    <div className="col-xl-3">
                      <span className="col-lg-8 view-label p">
                        {startDate ? Helper.DateNormal(startDate) : "None"}
                      </span>
                    </div>
                    <div className="col-xl-3">
                      <label className="col-lg-12 col-form-label">
                        {t("End Date")}{" "}
                        <Tooltip content={t("EndDate_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                    </div>
                    <div className="col-xl-3">
                      <span className="col-lg-8 view-label p">
                        {endDate ? Helper.DateNormal(endDate) : "None"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <ContentLoader
            viewBox="0 0 400 160"
            backgroundColor="rgba(0,0,0,0.06)"
            foregroundColor="rgba(0,0,0,0.12)"
          >
            <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
            <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
            <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
            <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
            <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
          </ContentLoader>
        )}
      </div>
    </>
  );
}

export default TaxRateView;
